// ボタンがクリックされたときの処理
function handleButtonClick(event) {
  const clickedButton = event.target;

  // 他のボタンから.is-activeクラスを削除
  const allButtons = document.querySelectorAll('.tagfilter__link');
  allButtons.forEach(button => button.classList.remove('is-active'));

  // クリックされたボタンに.is-activeクラスを追加
  clickedButton.classList.add('is-active');

  // クリックされたボタンの情報をLocal Storageに保存
  const buttonId = clickedButton.getAttribute('data-id');
  localStorage.setItem('activeButtonId', buttonId);
}

// ページが読み込まれたときに、Local Storageから情報を取得して適用
document.addEventListener('DOMContentLoaded', () => {
  const activeButtonId = localStorage.getItem('activeButtonId');
  if (activeButtonId) {
    const activeButton = document.querySelector(`.tagfilter__link[data-id="${activeButtonId}"]`);
    if (activeButton) {
      activeButton.classList.add('is-active');
    }
  }
});

// クリックイベントを各ボタンに追加
const allButtons = document.querySelectorAll('.tagfilter__link');
allButtons.forEach(button => {
  button.addEventListener('click', handleButtonClick);
});